// This directive places two panels in a page; the first panel displays a time graph of several of
// the BoxCaster's stats and allows for quick display of mouseover data. The second panel displays
// more detailed explosions of BoxCaster stats data for detailed diagnosis.
//
// This directive utilizes stats data obtained by the StatsService, which pulls stats data out
// of the the Graphite server.
angular.module('app.directives').directive('appBoxcasterGraph', ($timeout, $window, StatsService) =>
    ({
        restrict: 'E',
        scope: {
            boxcasterId: '='
        },
        controller($scope) {
            $scope.isPro = ($scope.boxcasterId[0] === 'p');
            $scope.totalMemory = ($scope.isPro ? 2103558144 : 90*1024*1024);
            $scope.maxVideoBitrate = ($scope.isPro ? 50000000 : 4800000);
            $scope.maxAudioBitrate = ($scope.isPro ? 320000 : 128000);
            $scope.numCores = ($scope.isPro ? 4 : 1);

            // The following keys are a starting point for all the data that will be retrieved for
            // display. Other keys are added by child graphs (via registerData).
            $scope.keys = [
                { field: 'last("total")', value: 'boxcaster.uptime', as: 'uptime.total' },
                { field: `${$scope.totalMemory} - mean("free")`, value: 'boxcaster.memory', as: 'memory.used' },
                { field: 'derivative(sum("video-buffer-count")) / 10', value: 'boxcaster.pipeline', as: 'pipeline.video-buffer-count' },
                { field: 'derivative(sum("video-byte-count")) * 8 / 10', value: 'boxcaster.pipeline', as: 'pipeline.video-byte-count' },
                { field: 'derivative(sum("audio-buffer-count")) / 10', value: 'boxcaster.pipeline', as: 'pipeline.audio-buffer-count' },
                { field: 'derivative(sum("audio-byte-count")) * 8 / 10', value: 'boxcaster.pipeline', as: 'pipeline.audio-byte-count' },
                { field: 'last("serial-src-is-open")', value: 'boxcaster.pipeline', as: 'pipeline.serial-src-is-open' },
                { field: 'derivative(sum("serial-bytes-received")) * 8 / 10', value: 'boxcaster.pipeline', as: 'pipeline.serial-bytes-received' },
                { field: 'last("carrier")', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.carrier', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("tx_packets")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.tx_packets', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("tx_bytes")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.tx_bytes', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("tx_errors")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.tx_errors', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("rx_packets")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.rx_packets', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("rx_bytes")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.rx_bytes', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("rx_errors")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.rx_errors', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("collisions")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.collisions', where: '"interface" =~ /eth0/' },
                { field: 'derivative(sum("multicast")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.ethernet.multicast', where: '"interface" =~ /eth0/' },
            ];
            $scope.timeoutId = null;
            $scope.hovering = false;
            $scope.detail = {
                cpu: {
                    open: false
                },
                encoder: {
                    open: false
                },
                video_inputs: {
                    open: false
                },
                sdi: {
                    open: false
                },
                hdmi: {
                    open: false
                },
                network: {
                    open: false
                }
            };

            if ($scope.isPro) {
                _.each([
                    { field: 'last("control-plane.logging")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.logging' },
                    { field: 'last("control-plane.miscellaneous")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.miscellaneous' },
                    { field: 'last("control-plane.remote-diagnostics")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.remote-diagnostics' },
                    { field: 'last("control-plane.stats-collection")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.stats-collection' },
                    { field: 'last("control-plane.stream-management")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.stream-management' },
                    { field: 'last("control-plane.ui-and-preview")', value: 'boxcaster.cpu.summary', as: 'cpu.control-plane.ui-and-preview' },
                    { field: 'last("data-plane.audio.capture")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.audio.capture' },
                    { field: 'last("data-plane.audio.encode")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.audio.encode' },
                    { field: 'last("data-plane.audio.monitor")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.audio.monitor' },
                    { field: 'last("data-plane.audio.payload")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.audio.payload' },
                    { field: 'last("data-plane.serial.capture-and-payload")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.serial.capture-and-payload' },
                    { field: 'last("data-plane.transmission")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.transmission' },
                    { field: 'last("data-plane.video.capture")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.video.capture' },
                    { field: 'last("data-plane.video.encode")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.video.encode' },
                    { field: 'last("data-plane.video.payload")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.video.payload' },
                    { field: 'last("data-plane.video.scale-and-preview")', value: 'boxcaster.cpu.summary', as: 'cpu.data-plane.video.scale-and-preview' }
                ], k => $scope.keys.push(k));
            } else {
                _.each([
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.BoxCasterRemo', where: '"component" =~ /BoxCasterRemo/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.DiagnosticSessi', where: '"component" =~ /DiagnosticSessi/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.EncoderGlibM', where: '"component" =~ /EncoderGlibM/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.IpcServermai', where: '"component" =~ /IpcServermai/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.Mainrun', where: '"component" =~ /Mainrun/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.Mainsignal', where: '"component" =~ /Mainsignal/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.PeriodicStatCol', where: '"component" =~ /PeriodicStatCol/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.PipelineGoverno', where: '"component" =~ /PipelineGoverno/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.ProcessControl', where: '"component" =~ /ProcessControl/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.StreamManagerr', where: '"component" =~ /StreamManagerr/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.SyslogTailerru', where: '"component" =~ /SyslogTailerru/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.VideoInputMonit', where: '"component" =~ /VideoInputMonit/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.alsasrcsrc', where: '"component" =~ /alsasrcsrc/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.alsasrc-analog', where: '"component" =~ /alsasrc-analog/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.alsasrc-embedde', where: '"component" =~ /alsasrc-embedde/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.audiomixerserc', where: '"component" =~ /audiomixerserc/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.audioqueuesrc', where: '"component" =~ /audioqueuesrc/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.audioqueue0src', where: '"component" =~ /audioqueue0src/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.audioqueue1src', where: '"component" =~ /audioqueue1src/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.audiosrc-ringbu', where: '"component" =~ /audiosrc-ringbu/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.boxcastcommsink', where: '"component" =~ /boxcastcommsink/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.boxcastserialsr', where: '"component" =~ /boxcastserialsr/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.dbclient_stdout', where: '"component" =~ /dbclient_stdout/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.dropbear_stdout', where: '"component" =~ /dropbear_stdout/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.pool', where: '"component" =~ /pool/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.ruby_timer_thr', where: '"component" =~ /ruby-timer-thr/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.ui_stdout', where: '"component" =~ /ui_stdout/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.v4l2srcsrc', where: '"component" =~ /v4l2srcsrc/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.vencsrc', where: '"component" =~ /vencsrc/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.videoqueue1src', where: '"component" =~ /videoqueue1src/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.videoqueue2src', where: '"component" =~ /videoqueue2src/' },
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.watchdog', where: '"component" =~ /watchdog/' }
                ], k => $scope.keys.push(k));
            }

            $scope.hasAdv7842 = _.include(['n', 'o'], $scope.boxcasterId[0]);
            if ($scope.hasAdv7842) {
                _.each([
                    { field: 'mean("system") + mean("user")', value: 'boxcaster.cpu.main', as: 'cpu.main.Adv7842Monitor', where: '"component" =~ /Adv7842Monitor/' },
                    { field: 'last("dsd")', value: 'boxcaster.adv7842.audio', as: 'adv7842.audio.dsd' },
                    { field: 'last("hbr")', value: 'boxcaster.adv7842.audio', as: 'adv7842.audio.hbr' },
                    { field: 'last("multi-channel")', value: 'boxcaster.adv7842.audio', as: 'adv7842.audio.multi-channel' },
                    { field: 'last("pcm")', value: 'boxcaster.adv7842.audio', as: 'adv7842.audio.pcm' },
                    { field: 'last("cts")', value: 'boxcaster.adv7842.clocks', as: 'adv7842.clocks.cts' },
                    { field: 'last("fs-khz")', value: 'boxcaster.adv7842.clocks', as: 'adv7842.clocks.fs-khz' },
                    { field: 'last("mclkout-mhz")', value: 'boxcaster.adv7842.clocks', as: 'adv7842.clocks.mclkout-mhz' },
                    { field: 'last("n")', value: 'boxcaster.adv7842.clocks', as: 'adv7842.clocks.n' },
                    { field: 'last("tmds-mhz")', value: 'boxcaster.adv7842.clocks', as: 'adv7842.clocks.tmds-mhz' },
                    { field: 'last("standard")', value: 'boxcaster.adv7842.composite', as: 'adv7842.composite.standard' },
                    { field: 'last("valid")', value: 'boxcaster.adv7842.composite', as: 'adv7842.composite.valid' },
                    { field: 'last("video-detected")', value: 'boxcaster.adv7842.composite', as: 'adv7842.composite.video-detected' },
                    { field: 'last("bl")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.bl' },
                    { field: 'last("cable-detected")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.cable-detected' },
                    { field: 'last("encrypted")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.encrypted' },
                    { field: 'last("fcl")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.fcl' },
                    { field: 'last("hdmi_mode")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.hdmi_mode' },
                    { field: 'last("interlaced")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.interlaced' },
                    { field: 'last("lcf")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.lcf' },
                    { field: 'last("lcvs")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.lcvs' },
                    { field: 'last("standard")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.standard' },
                    { field: 'last("valid")', value: 'boxcaster.adv7842.hdmi', as: 'adv7842.hdmi.valid' },
                    { field: 'last("audio-locked")', value: 'boxcaster.adv7842.plls', as: 'adv7842.plls.audio-locked' },
                    { field: 'last("tmds-locked")', value: 'boxcaster.adv7842.plls', as: 'adv7842.plls.tmds-locked' },
                ], k => $scope.keys.push(k));
            }

            if ($scope.isPro) {
                _.each([
                    { field: 'last("framerate")',              value: 'boxcaster.video.hdmi', as: 'hdmi.framerate' },
                    { field: 'last("height")',                 value: 'boxcaster.video.hdmi', as: 'hdmi.height' },
                    { field: 'last("interlaced")',             value: 'boxcaster.video.hdmi', as: 'hdmi.interlaced' },
                    { field: 'last("width")',                  value: 'boxcaster.video.hdmi', as: 'hdmi.width' },
                    { field: 'last("framerate")',              value: 'boxcaster.video.sdi',  as: 'sdi.framerate' },
                    { field: 'last("height")',                 value: 'boxcaster.video.sdi',  as: 'sdi.height' },
                    { field: 'last("interlaced")',             value: 'boxcaster.video.sdi',  as: 'sdi.interlaced' },
                    { field: 'last("width")',                  value: 'boxcaster.video.sdi',  as: 'sdi.width' },
                    { field: 'last("cable_length_m")',         value: 'boxcaster.lmh1219',    as: 'sdi.cable_length_m' },
                    { field: 'last("heo_ui")',                 value: 'boxcaster.lmh1219',    as: 'sdi.heo_ui' },
                    { field: 'last("link_rate")',              value: 'boxcaster.lmh1219',    as: 'sdi.link_rate' },
                    { field: 'last("locked")',                 value: 'boxcaster.lmh1219',    as: 'sdi.locked' },
                    { field: 'last("veo_mv")',                 value: 'boxcaster.lmh1219',    as: 'sdi.veo_mv' },
                ], k => $scope.keys.push(k));
            }

            $scope.hasPowerSequencer = ($scope.boxcasterId[0] === 'o');
            if ($scope.hasPowerSequencer) {
                $scope.keys.push({ field: 'mean("temperature")', value: 'boxcaster.powersequencer', as: 'powersequencer.temperature' });
            }

            // Add temperature data from the BoxCaster Pro
            if ($scope.isPro) {
                $scope.keys.push({ field: 'mean("ps")',                value: 'boxcaster.temperature',       as: 'temperature.ps' });
                $scope.keys.push({ field: 'mean("pl")',                value: 'boxcaster.temperature',       as: 'temperature.pl' });
                $scope.keys.push({ field: 'mean("max_touch_plastic")', value: 'boxcaster.temperature.model', as: 'temperature.max_touch_plastic' });
                $scope.keys.push({ field: 'mean("max_touch_metal")',   value: 'boxcaster.temperature.model', as: 'temperature.max_touch_metal' });
            }

            $scope.hasWireless = _.include(['o', 'p'], $scope.boxcasterId[0]);
            if ($scope.hasWireless) {
                let wifiInterfaceName = (($scope.boxcasterId[0] === 'p') ? 'mlan0' : 'wlan0');
                _.each([
                    { field: 'last("carrier")', value: 'boxcaster.network.interface', as: 'network.interface.wireless.carrier', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("tx_packets")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.tx_packets', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("tx_bytes")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.tx_bytes', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("tx_errors")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.tx_errors', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("rx_packets")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.rx_packets', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("rx_bytes")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.rx_bytes', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("rx_errors")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.rx_errors', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("collisions")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.collisions', where: `"interface" =~ /${wifiInterfaceName}/` },
                    { field: 'derivative(sum("multicast")) / 10', value: 'boxcaster.network.interface', as: 'network.interface.wireless.multicast', where: `"interface" =~ /${wifiInterfaceName}/` },
                ], k => $scope.keys.push(k));
            }

            // This data represents the individual stats for the specific time being shown.
            $scope.statsAtTime = {
                time: null,
                cpu: {
                    control_plane: {},
                    data_plane: {
                        video: {},
                        audio: {},
                        serial: {}
                    }
                },
                encoder: {},
                adv7842: {
                    audio: {},
                    clocks: {},
                    composite: {},
                    hdmi: {},
                    plls: {}
                },
                hdmi: {},
                sdi: {},
                network: {
                    interface: {
                        total_bytes: null,
                            ethernet: {},
                            wireless: {}
                    }
                }
            };

            // Convenience method to get stats values from one or more keys
            $scope.statsForTime = (keys, time) =>
                // Currently, all values are expected to be >= 0, so treat them here as null/invalid
                _.map(keys, k => ($scope.statsData[k] || {})[time]).reduce(function(a, b) {
                    if (((a === null) || (a === undefined) || (a < 0)) && ((b === null) || (b === undefined) || (b < 0))) {
                        return null;
                    } else if (((a !== null) && (a !== undefined) && (a >= 0)) && ((b === null) || (b === undefined) || (b < 0))) {
                        return a;
                    } else if (((a === null) || (a === undefined) || (a < 0)) && ((b !== null) && (b !== undefined) && (b >= 0))) {
                        return b;
                    } else {
                        return a + b;
                    }
                });
            this.statsForTime = $scope.statsForTime;

            $scope.timeInterval = '2h';
            $scope.fnsGraphWidthCallback = [];

            // This function is called by "child" graphs to add functions to be called when the graph
            // width is to be changed (e.g. in a window resize).
            this.registerGraphWidthCallback = fn => $scope.fnsGraphWidthCallback.push(fn);

            // This function will be periodically called to refresh stats data.
            var allowAutoRefresh = true;
            var refreshFn = function() {
                let request = StatsService.fetch({ time: [`time > now() - ${$scope.timeInterval}`], boxcaster: $scope.boxcasterId, targets: $scope.keys });
                return request.then(function(data) {
                    $scope.statsData = data;
                    if (allowAutoRefresh) $scope.timeoutId = $timeout(refreshFn, 10000);
                });
            };
            refreshFn();

            // This function is called to update the time interval of the stats data graph.
            $scope.updateTimeInterval = function(timeInterval) {
                $scope.timeInterval = timeInterval;
                if ($scope.timeoutId != null) {
                    $timeout.cancel($scope.timeoutId);
                }
                return refreshFn();
            };

            $scope.$on('$destroy', function() {
                allowAutoRefresh = false;
                $timeout.cancel($scope.timeoutId);
            });
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            // This function is a common function to show the BoxCaster stats for a specific moment in
            // time, based on either hovering over the chart, or showing the latest value.
            //
            // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
            // where, in the time window, data values should be shown.
            let showGraphStats = function(pct) {
                if (scope.statsData != null) {
                    // Update the time we're showing based on pct.
                    let times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);
                    times.sort((a, b) => a - b);
                    let time = times[Math.round(pct * (times.length - 1))];
                    scope.statsAtTime.time = time;

                    // Calculate the cpu busy and idle time.
                    let cpu = scope.statsForTime(_.filter(_.keys(scope.statsData), k => k.match(/^cpu\./)), time) / scope.numCores;
                    if (cpu > 100.0) { cpu = 100.0; }
                    scope.statsAtTime.cpu.busy = cpu;
                    scope.statsAtTime.cpu.idle = 100.0 - cpu;

                    // This block of code pulls out all the individual stats that are used below in the
                    // templates. Most of these are numeric, but some are converted to boolean.
                    if (scope.isPro) {
                        scope.statsAtTime.cpu.control_plane.logging = scope.statsForTime(['cpu.control-plane.logging'], time) / scope.numCores;
                        scope.statsAtTime.cpu.control_plane.miscellaneous = scope.statsForTime(['cpu.control-plane.miscellaneous'], time) / scope.numCores;
                        scope.statsAtTime.cpu.control_plane.remote_diagnostics = scope.statsForTime(['cpu.control-plane.remote-diagnostics'], time) / scope.numCores;
                        scope.statsAtTime.cpu.control_plane.stats_collection = scope.statsForTime(['cpu.control-plane.stats-collection'], time) / scope.numCores;
                        scope.statsAtTime.cpu.control_plane.stream_management = scope.statsForTime(['cpu.control-plane.stream-management'], time) / scope.numCores;
                        scope.statsAtTime.cpu.control_plane.ui_and_preview = scope.statsForTime(['cpu.control-plane.ui-and-preview'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.audio.capture = scope.statsForTime(['cpu.data-plane.audio.capture'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.audio.encode = scope.statsForTime(['cpu.data-plane.audio.encode'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.audio.monitor = scope.statsForTime(['cpu.data-plane.audio.monitor'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.audio.payload = scope.statsForTime(['cpu.data-plane.audio.payload'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.serial.capture_and_payload = scope.statsForTime(['cpu.data-plane.serial.capture-and-payload'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.transmission = scope.statsForTime(['cpu.data-plane.transmission'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.video.capture = scope.statsForTime(['cpu.data-plane.video.capture'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.video.encode = scope.statsForTime(['cpu.data-plane.video.encode'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.video.payload = scope.statsForTime(['cpu.data-plane.video.payload'], time) / scope.numCores;
                        scope.statsAtTime.cpu.data_plane.video.scale_and_preview = scope.statsForTime(['cpu.data-plane.video.scale-and-preview'], time) / scope.numCores;
                    } else {
                        scope.statsAtTime.cpu.video_input_monitoring = scope.statsForTime(['cpu.main.Adv7842Monitor', 'cpu.main.VideoInputMonit'], time) / scope.numCores;
                        scope.statsAtTime.cpu.remote_logging = scope.statsForTime(['cpu.main.BoxCasterRemo', 'cpu.main.SyslogTailerru'], time) / scope.numCores;
                        scope.statsAtTime.cpu.lifecycle_management = scope.statsForTime(['cpu.main.DiagnosticSessi', 'cpu.main.IpcServermai', 'cpu.main.StreamManagerr', 'cpu.main.Mainrun', 'cpu.main.Mainsignal', 'cpu.main.dbclient_stdout', 'cpu.main.dropbear_stdout', 'cpu.main.ruby_timer_thr', 'cpu.main.ui_stdout'], time) / scope.numCores;
                        scope.statsAtTime.cpu.watchdog = scope.statsForTime(['cpu.main.watchdog'], time) / scope.numCores;
                        scope.statsAtTime.cpu.metrics_collection = scope.statsForTime(['cpu.main.PeriodicStatCol'], time) / scope.numCores;
                        scope.statsAtTime.cpu.audio_capture = scope.statsForTime(['cpu.main.audiosrc-ringbu', 'cpu.main.alsasrcsrc', 'cpu.main.alsasrc-embedde', 'cpu.main.alsasrc-analog', 'cpu.main.audiomixerserc'], time) / scope.numCores;
                        scope.statsAtTime.cpu.audio_encoding = scope.statsForTime(['cpu.main.audioqueuesrc', 'cpu.main.audioqueue0src', 'cpu.main.audioqueue1src'], time) / scope.numCores;
                        scope.statsAtTime.cpu.video_capture = scope.statsForTime(['cpu.main.v4l2srcsrc'], time) / scope.numCores;
                        scope.statsAtTime.cpu.video_transmission = scope.statsForTime(['cpu.main.videoqueue1src', 'cpu.main.videoqueue2src', 'cpu.main.vencsrc'], time) / scope.numCores;
                        scope.statsAtTime.cpu.serial = scope.statsForTime(['cpu.main.boxcastserialsr'], time) / scope.numCores;
                        scope.statsAtTime.cpu.backhaul = scope.statsForTime(['cpu.main.boxcastcommsink', 'cpu.main.PipelineGoverno'], time) / scope.numCores;
                        scope.statsAtTime.cpu.housekeeping = scope.statsForTime(['cpu.main.EncoderGlibM', 'cpu.main.pool', 'cpu.main.ProcessControl'], time) / scope.numCores;
                    }
                    scope.statsAtTime.memory = scope.statsForTime(['memory.used'], time);
                    scope.statsAtTime.temperature = scope.statsForTime(['powersequencer.temperature'], time);
                    scope.statsAtTime.temperature_ps = scope.statsForTime(['temperature.ps'], time);
                    scope.statsAtTime.temperature_pl = scope.statsForTime(['temperature.pl'], time);
                    scope.statsAtTime.temperature_max_touch_plastic = scope.statsForTime(['temperature.max_touch_plastic'], time);
                    scope.statsAtTime.temperature_max_touch_metal = scope.statsForTime(['temperature.max_touch_metal'], time);
                    scope.statsAtTime.encoder.video_bitrate = scope.statsForTime(['pipeline.video-byte-count'], time);
                    scope.statsAtTime.encoder.video_buffer_rate = scope.statsForTime(['pipeline.video-buffer-count'], time);
                    scope.statsAtTime.encoder.audio_bitrate = scope.statsForTime(['pipeline.audio-byte-count'], time);
                    scope.statsAtTime.encoder.audio_buffer_rate = scope.statsForTime(['pipeline.audio-buffer-count'], time);
                    scope.statsAtTime.encoder.serial_bitrate = scope.statsForTime(['pipeline.serial-bytes-received'], time);
                    scope.statsAtTime.encoder.serial_src_is_open = scope.statsForTime(['pipeline.serial-src-is-open'], time);
                    scope.statsAtTime.adv7842.audio.dsd = scope.statsForTime(['adv7842.audio.dsd'], time);
                    if (scope.statsAtTime.adv7842.audio.dsd != null) { scope.statsAtTime.adv7842.audio.dsd = (scope.statsAtTime.adv7842.audio.dsd === 1 ? true : false); }
                    scope.statsAtTime.adv7842.audio.hbr = scope.statsForTime(['adv7842.audio.hbr'], time);
                    if (scope.statsAtTime.adv7842.audio.hbr != null) { scope.statsAtTime.adv7842.audio.hbr = (scope.statsAtTime.adv7842.audio.hbr === 1 ? true : false); }
                    scope.statsAtTime.adv7842.audio.multi_channel = scope.statsForTime(['adv7842.audio.multi-channel'], time);
                    if (scope.statsAtTime.adv7842.audio.multi_channel != null) { scope.statsAtTime.adv7842.audio.multi_channel = (scope.statsAtTime.adv7842.audio.multi_channel === 1 ? true : false); }
                    scope.statsAtTime.adv7842.audio.pcm = scope.statsForTime(['adv7842.audio.pcm'], time);
                    if (scope.statsAtTime.adv7842.audio.pcm != null) { scope.statsAtTime.adv7842.audio.pcm = (scope.statsAtTime.adv7842.audio.pcm === 1 ? true : false); }
                    scope.statsAtTime.adv7842.clocks.cts = scope.statsForTime(['adv7842.clocks.cts'], time);
                    scope.statsAtTime.adv7842.clocks.fs_khz = scope.statsForTime(['adv7842.clocks.fs-khz'], time);
                    scope.statsAtTime.adv7842.clocks.mclkout_mhz = scope.statsForTime(['adv7842.clocks.mclkout-mhz'], time);
                    scope.statsAtTime.adv7842.clocks.n = scope.statsForTime(['adv7842.clocks.n'], time);
                    scope.statsAtTime.adv7842.clocks.tmds_mhz = scope.statsForTime(['adv7842.clocks.tmds-mhz'], time);
                    scope.statsAtTime.adv7842.composite.standard = scope.statsForTime(['adv7842.composite.standard'], time);
                    scope.statsAtTime.adv7842.composite.valid = scope.statsForTime(['adv7842.composite.valid'], time);
                    if (scope.statsAtTime.adv7842.composite.valid != null) { scope.statsAtTime.adv7842.composite.valid = (scope.statsAtTime.adv7842.composite.valid === 1 ? true : false); }
                    scope.statsAtTime.adv7842.composite.video_detected = scope.statsForTime(['adv7842.composite.video-detected'], time);
                    if (scope.statsAtTime.adv7842.composite.video_detected != null) { scope.statsAtTime.adv7842.composite.video_detected = (scope.statsAtTime.adv7842.composite.video_detected === 1 ? true : false); }
                    scope.statsAtTime.adv7842.hdmi.bl = scope.statsForTime(['adv7842.hdmi.bl'], time);
                    scope.statsAtTime.adv7842.hdmi.cable_detected = scope.statsForTime(['adv7842.hdmi.cable-detected'], time);
                    if (scope.statsAtTime.adv7842.hdmi.cable_detected != null) { scope.statsAtTime.adv7842.hdmi.cable_detected = (scope.statsAtTime.adv7842.hdmi.cable_detected === 1 ? true : false); }
                    scope.statsAtTime.adv7842.hdmi.encrypted = scope.statsForTime(['adv7842.hdmi.encrypted'], time);
                    if (scope.statsAtTime.adv7842.hdmi.encrypted != null) { scope.statsAtTime.adv7842.hdmi.encrypted = (scope.statsAtTime.adv7842.hdmi.encrypted === 1 ? true : false); }
                    scope.statsAtTime.adv7842.hdmi.fcl = scope.statsForTime(['adv7842.hdmi.fcl'], time);
                    scope.statsAtTime.adv7842.hdmi.hdmi_mode = scope.statsForTime(['adv7842.hdmi.hdmi_mode'], time);
                    if (scope.statsAtTime.adv7842.hdmi.hdmi_mode != null) { scope.statsAtTime.adv7842.hdmi.hdmi_mode = (scope.statsAtTime.adv7842.hdmi.hdmi_mode === 1 ? 'HDMI' : 'DVI'); }
                    scope.statsAtTime.adv7842.hdmi.interlaced = scope.statsForTime(['adv7842.hdmi.interlaced'], time);
                    if (scope.statsAtTime.adv7842.hdmi.interlaced != null) { scope.statsAtTime.adv7842.hdmi.interlaced = (scope.statsAtTime.adv7842.hdmi.interlaced === 1 ? true : false); }
                    scope.statsAtTime.adv7842.hdmi.lcf = scope.statsForTime(['adv7842.hdmi.lcf'], time);
                    scope.statsAtTime.adv7842.hdmi.lcvs = scope.statsForTime(['adv7842.hdmi.lcvs'], time);
                    scope.statsAtTime.adv7842.hdmi.standard = scope.statsForTime(['adv7842.hdmi.standard'], time);
                    scope.statsAtTime.adv7842.hdmi.valid = scope.statsForTime(['adv7842.hdmi.valid'], time);
                    if (scope.statsAtTime.adv7842.hdmi.valid != null) { scope.statsAtTime.adv7842.hdmi.valid = (scope.statsAtTime.adv7842.hdmi.valid === 1 ? true : false); }
                    scope.statsAtTime.adv7842.plls.audio_locked = scope.statsForTime(['adv7842.plls.audio-locked'], time);
                    if (scope.statsAtTime.adv7842.plls.audio_locked != null) { scope.statsAtTime.adv7842.plls.audio_locked = (scope.statsAtTime.adv7842.plls.audio_locked === 1 ? true : false); }
                    scope.statsAtTime.adv7842.plls.tmds_locked = scope.statsForTime(['adv7842.plls.tmds-locked'], time);
                    if (scope.statsAtTime.adv7842.plls.tmds_locked != null) { scope.statsAtTime.adv7842.plls.tmds_locked = (scope.statsAtTime.adv7842.plls.tmds_locked === 1 ? true : false); }
                    scope.statsAtTime.hdmi.framerate = scope.statsForTime(['hdmi.framerate'], time);
                    scope.statsAtTime.hdmi.height = scope.statsForTime(['hdmi.height'], time);
                    scope.statsAtTime.hdmi.interlaced = scope.statsForTime(['hdmi.interlaced'], time);
                    if (scope.statsAtTime.hdmi.interlaced != null) { scope.statsAtTime.hdmi.interlaced = (scope.statsAtTime.hdmi.interlaced === 1 ? true : false); }
                    scope.statsAtTime.hdmi.width = scope.statsForTime(['hdmi.width'], time);
                    scope.statsAtTime.sdi.framerate = scope.statsForTime(['sdi.framerate'], time);
                    scope.statsAtTime.sdi.height = scope.statsForTime(['sdi.height'], time);
                    scope.statsAtTime.sdi.interlaced = scope.statsForTime(['sdi.interlaced'], time);
                    if (scope.statsAtTime.sdi.interlaced != null) { scope.statsAtTime.sdi.interlaced = (scope.statsAtTime.sdi.interlaced === 1 ? true : false); }
                    scope.statsAtTime.sdi.width = scope.statsForTime(['sdi.width'], time);
                    scope.statsAtTime.sdi.cable_length_m = scope.statsForTime(['sdi.cable_length_m'], time);
                    scope.statsAtTime.sdi.heo_ui = scope.statsForTime(['sdi.heo_ui'], time);
                    scope.statsAtTime.sdi.link_rate = scope.statsForTime(['sdi.link_rate'], time);
                    scope.statsAtTime.sdi.locked = scope.statsForTime(['sdi.locked'], time);
                    if (scope.statsAtTime.sdi.locked != null) { scope.statsAtTime.sdi.locked = (scope.statsAtTime.sdi.locked === 1 ? true : false); }
                    scope.statsAtTime.sdi.veo_mv = scope.statsForTime(['sdi.veo_mv'], time);
                    scope.statsAtTime.sdi.errors = scope.statsForTime(['sdi.errors'], time);
                    scope.statsAtTime.network.interface.ethernet.tx_bytes = scope.statsForTime(['network.interface.ethernet.tx_bytes'], time);
                    scope.statsAtTime.network.interface.ethernet.rx_bytes = scope.statsForTime(['network.interface.ethernet.rx_bytes'], time);
                    scope.statsAtTime.network.interface.wireless.tx_bytes = scope.statsForTime(['network.interface.wireless.tx_bytes'], time);
                    scope.statsAtTime.network.interface.wireless.rx_bytes = scope.statsForTime(['network.interface.wireless.rx_bytes'], time);
                    if ((scope.statsAtTime.network.interface.ethernet.tx_bytes != null) || (scope.statsAtTime.network.interface.ethernet.rx_bytes != null) || (scope.statsAtTime.network.interface.wireless.tx_bytes != null) || (scope.statsAtTime.network.interface.wireless.rx_bytes != null)) {
                        scope.statsAtTime.network.interface.total_bytes = (scope.statsAtTime.network.interface.ethernet.tx_bytes || 0) + (scope.statsAtTime.network.interface.ethernet.rx_bytes || 0) + (scope.statsAtTime.network.interface.wireless.tx_bytes || 0) + (scope.statsAtTime.network.interface.wireless.rx_bytes || 0);
                    } else {
                        scope.statsAtTime.network.interface.total_bytes = null;
                    }
                    scope.statsAtTime.network.interface.ethernet.carrier = scope.statsForTime(['network.interface.ethernet.carrier'], time);
                    if (scope.statsAtTime.network.interface.ethernet.carrier != null) { scope.statsAtTime.network.interface.ethernet.carrier = (scope.statsAtTime.network.interface.ethernet.carrier === 1 ? true : false); }
                    scope.statsAtTime.network.interface.wireless.carrier = scope.statsForTime(['network.interface.wireless.carrier'], time);
                    if (scope.statsAtTime.network.interface.wireless.carrier != null) { scope.statsAtTime.network.interface.wireless.carrier = (scope.statsAtTime.network.interface.wireless.carrier === 1 ? true : false); }
                    scope.statsAtTime.network.interface.ethernet.tx_packets = scope.statsForTime(['network.interface.ethernet.tx_packets'], time);
                    scope.statsAtTime.network.interface.wireless.tx_packets = scope.statsForTime(['network.interface.wireless.tx_packets'], time);
                    scope.statsAtTime.network.interface.ethernet.tx_errors = scope.statsForTime(['network.interface.ethernet.tx_errors'], time);
                    scope.statsAtTime.network.interface.wireless.tx_errors = scope.statsForTime(['network.interface.wireless.tx_errors'], time);
                    scope.statsAtTime.network.interface.ethernet.rx_packets = scope.statsForTime(['network.interface.ethernet.rx_packets'], time);
                    scope.statsAtTime.network.interface.wireless.rx_packets = scope.statsForTime(['network.interface.wireless.rx_packets'], time);
                    scope.statsAtTime.network.interface.ethernet.rx_errors = scope.statsForTime(['network.interface.ethernet.rx_errors'], time);
                    scope.statsAtTime.network.interface.wireless.rx_errors = scope.statsForTime(['network.interface.wireless.rx_errors'], time);
                    scope.statsAtTime.network.interface.ethernet.collisions = scope.statsForTime(['network.interface.ethernet.collisions'], time);
                    scope.statsAtTime.network.interface.wireless.collisions = scope.statsForTime(['network.interface.wireless.collisions'], time);
                    scope.statsAtTime.network.interface.ethernet.multicast = scope.statsForTime(['network.interface.ethernet.multicast'], time);
                    return scope.statsAtTime.network.interface.wireless.multicast = scope.statsForTime(['network.interface.wireless.multicast'], time);
                }
            };

            // This function calculates the extents of the embedded graph area.
            let getGraphExtents = function() {
                let graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
                graphExtents.width = $(element).find('td .rickshaw_graph').width();
                graphExtents.height = $(element).find('table').height();
                return graphExtents;
            };

            // This function is called whenever the graph is hovered over (when the mouse enters or moves
            // over the graph area).
            let onGraphHoverEnter = evt =>
                scope.$apply(function() {
                    let graphExtents = getGraphExtents();
                    let offset_left = $(evt.currentTarget).parents('app-boxcaster-graph').offset().left;
                    $(element).find('#cursor').css('left', (evt.clientX - offset_left - 2) + 'px');
                    $(element).find('#cursor').show();
                    let pct = ((evt.clientX - (offset_left + graphExtents.left)) * 1.0) / graphExtents.width;
                    if ((pct != null) && (pct >= 0.0) && (pct <= 1.0)) {
                        showGraphStats(pct);
                        return scope.hovering = true;
                    }
                });

            // This function is called whenever the mouse leaves the graph area.
            let onGraphHoverExit = evt =>
                scope.$apply(function() {
                    $(element).find('#cursor').hide();
                    showGraphStats(1.0);
                    return scope.hovering = false;
                });

            $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
            $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter);

            // Run whenever the stats data is refreshed from the stats service.
            scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    if (!scope.hovering) { showGraphStats(1.0); }

                    // We use the uptime data to figure out when the BoxCaster is actually offline/rebooted
                    // (vs. just being busy and missing stats update intervals). Here we calculate those
                    // gaps.
                    let uptimeData = newval['uptime.total'];
                    if (uptimeData != null) {
                        // Remove any existing 'reboot' rectangles
                        $(element).find('.reboot').remove();

                        // Sort uptime data and remove nulls.
                        uptimeData = angular.copy(uptimeData);
                        let times = _.keys(uptimeData);
                        times.sort((a, b) => a - b);
                        let startTime = times[0];
                        let endTime = times[times.length - 1];
                        _.each(uptimeData, function(v, k) {
                            if (v == null) {
                                return delete uptimeData[k];
                            }
                        });

                        // Here we calculate each spot where it looks like the BoxCaster rebooted. Our
                        // rubric for determining whether a reboot happened is if the actual time between log
                        // entries has advanced by 30 seconds or more, and the uptime value has either not
                        // advanced or has gone backwards.
                        let reboots = [];
                        let lastTime = null;
                        let lastVal = null;
                        _.each(uptimeData, function(val, time, arr) {
                            time = parseInt(time);
                            if ((lastTime != null) && (lastVal != null)) {
                                if (((time - lastTime) >= 30.0) && ((val - lastVal) <= 0)) {
                                    reboots.push({ from: lastTime, to: time });
                                }
                            }
                            lastTime = time;
                            return lastVal = val;
                        });

                        // For each 'reboot', add a rectangle to the graph to represent it.
                        let graphExtents = getGraphExtents();
                        _.each(reboots, function(r) {
                            let left = graphExtents.left + (((r.from - startTime) * graphExtents.width * 1.0) / (endTime - startTime));
                            let width = ((r.to - r.from) * graphExtents.width * 1.0) / (endTime - startTime);
                            return $(element).find('#boxcaster-chart-panel').append(`<div class="reboot" style="left: ${left}px; top: 0px; width: ${width}px; height: 100%;" data-from="${r.from}" data-to="${r.to}"></div>`);
                        });

                        // Reconnect our hover handlers for the reboot rectangles.
                        $(element).find('.reboot').hover(onGraphHoverEnter, onGraphHoverExit);
                        return $(element).find('.reboot').mousemove(onGraphHoverEnter);
                    }
                }
            });

            // When the window is resized, we need to manually update the child graphs' sizes, since
            // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.
            angular.element($window).bind('resize', function() {
                // The actual graph width is the panel width minus the width of the first and last columns.
                let panelWidth = $(element).find('#boxcaster-chart-panel')[0].getBoundingClientRect().width;
                let prevColWidth = $(element).find('#boxcaster-chart-panel table tr th')[0].getBoundingClientRect().width;
                let nextColWidth = $(element).find('#boxcaster-chart-panel table tr td')[1].getBoundingClientRect().width;
                return _.each(scope.fnsGraphWidthCallback, fn => fn.call(null, panelWidth - prevColWidth - nextColWidth));
            });

            return element.on('$destroy', function() {
                if (scope.timeoutId != null) {
                    return $timeout.cancel(scope.timeoutId);
                }
            });
        },

        template: `
      <div class="panel panel-default">
        <div class="panel-heading">
          Diagnostics
          <div class="btn-group btn-group-xs" role="group">
            <button type="button" class="btn btn-default" ng-click="updateTimeInterval('4h')" ng-class="{'active': timeInterval == '4h'}">4h</button>
            <button type="button" class="btn btn-default" ng-click="updateTimeInterval('2h')" ng-class="{'active': timeInterval == '2h'}">2h</button>
            <button type="button" class="btn btn-default" ng-click="updateTimeInterval('30m')" ng-class="{'active': timeInterval == '30m'}">30m</button>
          </div>
          <span ng-show="!!statsAtTime.time">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>
        </div>
        <div class="panel-body" id="boxcaster-chart-panel" style="padding: 0px;">
          <table class="table" style="width: 100%; margin: 0px;">
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">CPU</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-cpu-graph stats-data="statsData" num-cores="numCores"></app-boxcaster-cpu-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.cpu.busy | numberWithUnit:1:'%' }}</div>
              </td>
            </tr>
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Memory</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-single-value-graph stats-data="statsData" renderer="area" min="0" max="{{ ::totalMemory }}" color="rgb(160,160,255)" target="memory.used"></app-boxcaster-single-value-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.memory | metricPrefix:'B' }}</div>
              </td>
            </tr>
            <tr ng-show="::hasPowerSequencer" class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Temperature</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-single-value-graph stats-data="statsData" renderer="line" min="-20" max="107.5" color="rgb(128,176,128)" target="powersequencer.temperature"></app-boxcaster-single-value-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.temperature | numberWithUnit:1:"&deg;C" }}</div>
              </td>
            </tr>
            <tr ng-show="::isPro" class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Temperature</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-pro-temperature-graph stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-pro-temperature-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">
                  <span ng-hide="statsAtTime.temperature_max_touch_plastic">
                    PS: {{ statsAtTime.temperature_ps | numberWithUnit:1:"&deg;C" }} <br/>
                    PL: {{ statsAtTime.temperature_pl | numberWithUnit:1:"&deg;C" }}
                  </span>
                  <span ng-show="statsAtTime.temperature_max_touch_plastic">
                    Plastic: {{ statsAtTime.temperature_max_touch_plastic | numberWithUnit:1:"&deg;C" }} <br/>
                    Metal: {{ statsAtTime.temperature_max_touch_metal | numberWithUnit:1:"&deg;C" }}
                  </span>
                </div>
              </td>
            </tr>
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Video Bitrate</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-single-value-graph stats-data="statsData" renderer="area" min="0" max="{{ ::maxVideoBitrate }}" color="rgb(64,96,128)" target="pipeline.video-byte-count"></app-boxcaster-single-value-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.encoder.video_bitrate | metricPrefix:'bps' }}</div>
              </td>
            </tr>
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Audio Bitrate</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-single-value-graph stats-data="statsData" renderer="area" min="0" max="{{ ::maxAudioBitrate }}" color="rgb(128,96,64)" target="pipeline.audio-byte-count"></app-boxcaster-single-value-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.encoder.audio_bitrate | metricPrefix:'bps' }}</div>
              </td>
            </tr>
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Serial Bitrate</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-serial-input-graph stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-serial-input-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.encoder.serial_bitrate | metricPrefix:'bps' }}</div>
              </td>
            </tr>
            <tr ng-show="::hasAdv7842" class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Video Inputs</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-video-inputs-graph stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-video-inputs-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.adv7842 | detectedVideoInput }}</div>
              </td>
            </tr>
            <tr ng-show="::isPro" class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">SDI Input</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-pro-video-inputs-graph which="sdi" stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-pro-video-inputs-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.sdi | detectedProVideoInput }}</div>
              </td>
            </tr>
            <tr ng-show="::isPro" class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">HDMI Input</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-pro-video-inputs-graph which="hdmi" stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-pro-video-inputs-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.hdmi | detectedProVideoInput }}</div>
              </td>
            </tr>
            <tr class="boxcaster-diagnostic-graph-row">
              <th class="boxcaster-diagnostic-graph-rowhead">Network</th>
              <td class="boxcaster-diagnostic-graph-cell">
                <app-boxcaster-network-graph stats-data="statsData" boxcaster-id="{{ boxcasterId }}"></app-boxcaster-network-graph>
              </td>
              <td>
                <div class="boxcaster-diagnostic-graph-value">{{ statsAtTime.network.interface.total_bytes | metricPrefix:'Bps' }}</div>
              </td>
            </tr>
          </table>
          <div id="cursor" class="cursor"></div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading">Diagnostics Detail <span ng-show="!!statsAtTime.time">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span></div>
        <div class="panel-body">
          <table class="table" style="width: 100%; margin: 0px;">
            <tr>
              <th>CPU <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-down': detail.cpu.open, 'glyphicon-chevron-right': !detail.cpu.open}" ng-click="detail.cpu.open = !detail.cpu.open"></i></th>
              <td style="width: 90%">
                <div collapse="!detail.cpu.open">
                  <table class="boxcaster-stats-detail" id="boxcaster-cpu-detail" ng-if="::!isPro">
                    <tr ng-if="::hasAdv7842">
                      <td>Video Input Monitoring:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.video_input_monitoring | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>Remote Logging:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.remote_logging | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>Lifecycle Management:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.lifecycle_management | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>Watchdog:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.watchdog | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>Metrics Collection:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.metrics_collection | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">Encoder</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio Capture:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.audio_capture | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio Encoding and Payloading:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.audio_encoding | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video Capture and Encoding:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.video_capture | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video Payloading:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.video_transmission | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Serial Capture/Encode/Payload:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.serial | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Backhaul:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.backhaul | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Housekeeping:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.housekeeping | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td><i>Idle:</i></td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.idle | numberWithUnit:1:'%' }}</td>
                    </tr>
                  </table>
                  <table class="boxcaster-stats-detail" id="boxcaster-cpu-detail" ng-if="::isPro">
                    <tr>
                      <td colspan="2">Data Plane</td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;&nbsp;Video</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.video.capture | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encode:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.video.encode | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Payload:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.video.payload | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Scale/preview:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.video.scale_and_preview | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;&nbsp;Audio</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.audio.capture | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encode:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.audio.encode | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Payload:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.audio.payload | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Monitor:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.audio.monitor | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;&nbsp;Serial</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture/payload:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.serial.capture_and_payload | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Transmission/backhaul:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.data_plane.transmission | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">Control Plane</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;UI and preview:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.ui_and_preview | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Stream Management:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.stream_management | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Stats Collection:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.stats_collection | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Logging:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.logging | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Remote Diagnostics:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.remote_diagnostics | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;Miscellaneous:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.control_plane.miscellaneous | numberWithUnit:1:'%' }}</td>
                    </tr>
                    <tr>
                      <td><i>Idle:</i></td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.cpu.idle | numberWithUnit:1:'%' }}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <th>Encoder <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-down': detail.encoder.open, 'glyphicon-chevron-right': !detail.encoder.open}" ng-click="detail.encoder.open = !detail.encoder.open"></i></th>
              <td style="width: 90%">
                <div collapse="!detail.encoder.open">
                  <table class="boxcaster-stats-detail" id="boxcaster-encoder-detail">
                    <tr>
                      <td>Video bitrate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.video_bitrate | metricPrefix:'bps' }}</td>
                    </tr>
                    <tr>
                      <td>Video buffer rate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.video_buffer_rate | number:1 }}</td>
                    </tr>
                    <tr>
                      <td>Audio bitrate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.audio_bitrate | metricPrefix:'bps' }}</td>
                    </tr>
                    <tr>
                      <td>Audio buffer rate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.audio_buffer_rate | number:1 }}</td>
                    </tr>
                    <tr>
                      <td>Serial bitrate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.serial_bitrate | metricPrefix:'bps' }}</td>
                    </tr>
                    <tr>
                      <td>Serial source is open:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.encoder.serial_src_is_open | boolean }}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
            <tr ng-if="::isPro">
              <th>SDI Input <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-down': detail.sdi.open, 'glyphicon-chevron-right': !detail.sdi.open}" ng-click="detail.sdi.open = !detail.sdi.open"></i></th>
              <td style="width: 90%">
                <div collapse="!detail.sdi.open">
                  <table class="boxcaster-stats-detail" id="boxcaster-sdi-detail">
                    <tr>
                      <td>Video standard:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.sdi | detectedProVideoInput }}</td>
                    </tr>
                    <tr>
                      <td>Locked:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.sdi.locked | boolean }}</td>
                    </tr>
                    <tr>
                      <td>Link rate:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.sdi.link_rate | sdiLinkRate }}</td>
                    </tr>
                    <tr>
                      <td>Cable length (m, approximate):</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.sdi.cable_length_m | number:0 }}</td>
                    </tr>
                    <tr>
                      <td>HEO/VEO:</td>
                      <td class="boxcaster-stats-detail-value">{{ [statsAtTime.sdi.heo_ui, statsAtTime.sdi.veo_mv] | sdiHeoVeo }}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
            <tr ng-if="::hasAdv7842">
              <th>Video Inputs <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-down': detail.video_inputs.open, 'glyphicon-chevron-right': !detail.video_inputs.open}" ng-click="detail.video_inputs.open = !detail.video_inputs.open"></i></th>
              <td style="width: 90%">
                <div collapse="!detail.video_inputs.open">
                  <table class="boxcaster-stats-detail" id="boxcaster-video-inputs-detail">
                    <tr>
                      <td colspan="2">Composite input</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video detected:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.composite.video_detected | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Valid standard:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.composite.valid | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Detected standard:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.composite.standard | compositeStandard }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">HDMI input</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Cable detected:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.cable_detected | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Valid standard:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.valid | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Detected standard:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi | hdmiStandard }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Mode:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.hdmi_mode }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encrypted:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.encrypted | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;BL:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.bl }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;LCVS:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.lcvs }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;LCF:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.lcf }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;FCL:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.fcl }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Interlaced:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.hdmi.interlaced | boolean }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">Audio</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio packet type:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.audio | audioPacketFormat }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio PLL locked:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.plls.audio_locked | boolean }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">Clocking</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;CTS:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.clocks.cts }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;N:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.clocks.n }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;F<sub>S</sub>:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.clocks.fs_khz | numberWithUnit:3:'kHz' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;MCLK out:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.clocks.mclkout_mhz | numberWithUnit:3:'MHz' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TMDS:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.clocks.tmds_mhz | numberWithUnit:3:'MHz' }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TMDS PLL locked:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.adv7842.plls.tmds_locked | boolean }}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <th>Network <i class="pull-right glyphicon" ng-class="{'glyphicon-chevron-down': detail.network.open, 'glyphicon-chevron-right': !detail.network.open}" ng-click="detail.network.open = !detail.network.open"></i></th>
              <td style="width: 90%">
                <div collapse="!detail.network.open">
                  <table class="boxcaster-stats-detail" id="boxcaster-network-detail">
                    <tr>
                      <td colspan="2">Wired:</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Connected:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.ethernet.carrier | boolean }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TX bytes / packets / errors:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.ethernet.tx_bytes }} / {{ statsAtTime.network.interface.ethernet.tx_packets }} / {{ statsAtTime.network.interface.ethernet.tx_errors }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;RX bytes / packets / errors:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.ethernet.rx_bytes }} / {{ statsAtTime.network.interface.ethernet.rx_packets }} / {{ statsAtTime.network.interface.ethernet.rx_errors }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Collisions:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.ethernet.collisions }}</td>
                    </tr>
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Multicast:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.ethernet.multicast }}</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td colspan="2">Wireless:</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Connected:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.wireless.carrier | boolean }}</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TX bytes / packets / errors:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.wireless.tx_bytes }} / {{ statsAtTime.network.interface.wireless.tx_packets }} / {{ statsAtTime.network.interface.wireless.tx_errors }}</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;RX bytes / packets / errors:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.wireless.rx_bytes }} / {{ statsAtTime.network.interface.wireless.rx_packets }} / {{ statsAtTime.network.interface.wireless.rx_errors }}</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Collisions:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.wireless.collisions }}</td>
                    </tr>
                    <tr ng-if="::hasWireless">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Multicast:</td>
                      <td class="boxcaster-stats-detail-value">{{ statsAtTime.network.interface.wireless.multicast }}</td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    `
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_graph.js